import { useEffect } from 'react';
import { useCreateMachine } from 'fsm';
import { machine as machineDefinition } from './machine';
import { CRMSearchContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export function CRMSearchProvider({
  children,
  query,
  selectionIds,
  selectionMethod
}) {
  const machine = useCreateMachine(machineDefinition, {
    initialContext: {
      query: null,
      data: null,
      error: null,
      selectionIds: selectionIds || [],
      selectionMethod: selectionMethod || 'BY_QUERY'
    }
  });
  const {
    send,
    state
  } = machine;
  useEffect(() => {
    if (!state.isRunning()) {
      return;
    }
    if (selectionMethod === 'BY_IDS' && selectionIds && selectionIds.length > 0) {
      send({
        type: 'SELECT_BY_IDS',
        selectionIds
      });
    } else if (query) {
      send({
        type: 'SEARCH',
        query
      });
    }
  }, [query, selectionIds, selectionMethod, send, state]);
  return /*#__PURE__*/_jsx(CRMSearchContext.Provider, {
    value: machine,
    children: children
  });
}